export const TAXRATE_GET = 'TAXRATE_GET';
export const TAXRATE_ERROR = 'TAXRATE_ERROR';
export const TAXRATE_LOADING = 'TAXRATE_LOADING';
export const TAX_RATE_SETUP_GET_SITES = 'TAX_RATE_SETUP_GET_SITES';
export const TAX_RATE_SETUP_GET_SITES_ERROR = 'TAX_RATE_SETUP_GET_SITES_ERROR';
export const TAX_RATE_SETUP_SAVE_SITES_SUCCESSFUL =
  'TAX_RATE_SETUP_SAVE_SITES_SUCCESSFUL';
export const TAX_RATE_SETUP_SAVE_SITES_ERROR =
  'TAX_RATE_SETUP_SAVE_SITES_ERROR';
export const TAX_RATE_SETUP_GET_TAX_RATES = 'TAX_RATE_SETUP_GET_TAX_RATES';
export const TAX_RATE_SETUP_GET_TAX_RATES_ERROR =
  'TAX_RATE_SETUP_GET_TAX_RATES_ERROR';
export const TAX_RATE_SETUP_CLEAR_ERRORS = 'TAX_RATE_SETUP_CLEAR_ERRORS';
export const TAX_RATE_SETUP_SAVE_SUCCESSFUL = 'TAX_RATE_SETUP_SAVE_SUCCESSFUL';
export const TAX_RATE_SETUP_SAVE_DELETE_SUCCESSFUL =
  'TAX_RATE_SETUP_SAVE_DELETE_SUCCESSFUL';



// WEBPACK FOOTER //
// ./src/pages/controlinformation/state/taxRates/types.js